import { SETTING_DEFAULTS, type Settings } from '@wiztime/core';
import { queries } from '@wiztime/storage';
import { useLive, type LiveResult } from './useLive';
import { useStore } from './useServices';

/** Synced settings with loading state (for code that must wait for the real values). */
export function useSettingsState(): LiveResult<Settings> {
  const store = useStore();
  return useLive(() => queries.settings(store.repo), [store]);
}

/** Synced settings; the defaults while the first read is pending. */
export function useSettings(): Settings {
  return useSettingsState().data ?? SETTING_DEFAULTS;
}
